<template>
    <div class="xml-upload-request-result">
        <span class="tag" :class="klass">
            {{ title }}
        </span>
    </div>
</template>

<script>
export default {
    name: "XmlUploadRequestResult",
    props: {
        request: Object,
    },
    computed: {
        klass() {
            if (this.request.result === 1) {
                return 'is-success';
            } else if (this.request.result === 2) {
                return 'is-warning'
            } else if (this.request.result === 3) {
              return 'is-primary'
            } else if (this.request.finished_at && !this.request.target_build_id) {
                return 'is-danger'
            } else if (this.request.finished_at && this.request.target_build_id) {
                return 'is-warning'
            } else {
                return 'is-info';
            }
        },
        title() {
            if (this.request.result === 1) {
                return 'SUCCESS';
            } else if (this.request.result === 2) {
                return 'INCORRECT XML'
            } else if (this.request.result === 3) {
              return 'NO XML FILE'
            } else if (this.request.finished_at && !this.request.target_build_id) {
                return 'FAILED'
            } else if (this.request.finished_at && this.request.target_build_id) {
                return 'NO XML'
            } else {
                return 'PROCESSING';
            }
        }
    }
}
</script>

<style scoped>

</style>